import React from "react";

export function Alert({ children, variant = "default", ...props }) {
  return (
    <div
      role="alert"
      className={`rounded-lg border p-4 ${
        variant === "destructive"
          ? "border-red-500/50 text-red-500"
          : "border-gray-200"
      }`}
      {...props}
    >
      {children}
    </div>
  )
}

export function AlertDescription({ children, ...props }) {
  return (
    <div className="text-sm [&_p]:leading-relaxed" {...props}>
      {children}
    </div>
  )
}
